import { Dialog, DialogContent } from '@/components/ui/dialog';

type Props = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export function EscrowInvitationDialog({ open, onClose, children }: Props) {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) onClose();
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-lg md:p-6 gap-6">{children}</DialogContent>
    </Dialog>
  );
}
